 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		123: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		123: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"29":"menuDe","30":"menuEn","31":"menuEs","32":"menuFr","33":"styles","124":"staticTextDe","125":"staticTextES","126":"staticTextEn","127":"staticTextEs","128":"staticTextFr","129":"videojsplugins"}[chunkId]||chunkId) + "." + {"0":"2b3b9a827176a0cd9d34","1":"fb0c25a7ce60c8ce8747","2":"575b435c8b036af65191","3":"3788067a0f03e3d9c5a4","4":"c4620e78836f7f74b09a","5":"55841277901c03dabc6c","6":"be78d45ff9a8c3cdf0a4","7":"dbdea9a6148078c54dc1","8":"8557c96dd13d44a0ef91","9":"55fcdb8ad82856bb69df","10":"bec38e57d67c07bc12e5","11":"d3211a9a4449f1843d65","12":"b31f6379fe597116aecb","13":"129dd1089af1dfc2f0d1","14":"f9c369befbcc2347b028","15":"dbd5ebfcd2eb5705c820","16":"b4839e119385d0175106","17":"02097a202037a4ef4778","18":"1a40b11cd4428289f468","19":"0a7886e01f7cb746b738","20":"44d3ce1554fccc4575ed","21":"523613b2cddedadfb88f","22":"85cf0430fdef32381717","23":"bcf9bdb8c151f4665c95","24":"68672826f07699bfa284","25":"9f6102d6949253df30fa","26":"8da4af36c293f95ea570","27":"816b8eff575a2b8694a5","28":"f0339d32b48b79b03940","29":"e8ef9f7b42bf4ec6c41e","30":"f99319952115f42914a6","31":"acf2b4c64e1250ecc5b6","32":"9084f8323c90bf3c841c","33":"6369957b5b09a0223376","34":"59bd11e96a1635ab87dd","35":"578e6bcbdb84d285244f","36":"3bc097ef84ba680bafdb","37":"a8464dfc8be7e7daab36","38":"b1bbb565dd95693a16c8","39":"9e483bdf45ab8cf21b84","40":"2f5c59ec909d58a64008","41":"d0e8965e427f9f4c64a6","42":"55f4c2f41e43ac802fbb","43":"715608c772f8fdcd244e","44":"b7d9f5a1c0dc48e03710","45":"1184065d2a0084cc416e","46":"3f604c63b8f73994fc3f","47":"a36135c84c037ef56213","48":"3ee8994c8f70070ee3aa","49":"8352e1e8aaf86a5c0667","50":"b7fc21e7146fe41a5d35","51":"98a6d0048ebaabcee159","52":"0d0f2046f38f5722cd9c","53":"38fbe47c1525d74f4cb7","54":"861092ec960a57509ad1","55":"5d7029b3f8d0783ca6b3","56":"691b45f0171611746c02","57":"d4e63f3fca5bb6971a1c","58":"3def24c1d14c61e8f43f","59":"54977a35552c8ba73d0f","60":"57faae1e51a8d67993b5","61":"f280ad30b42c9f18789c","62":"3c18a7653217284086d7","63":"571e217d2f5ad5ec1171","64":"5aaac4c8f88d5b999309","65":"eb1e777f6c3351b98d14","66":"406d121b62b6d0fedd11","67":"b8537d12ddc939824d0b","68":"f52c445734810a4a7dfe","69":"d1a87436634f6d04ea56","70":"d299ff722af37d5ed8e4","71":"24ae86a1403a3015b376","72":"9fda1f9ddfcb57fa3830","73":"9ece92cd8ac4a162dace","74":"bf73a066fc56784a70c0","75":"6e2c8ac2bd93579ac92c","76":"54475f156a3fc78ce8b1","77":"f85a0bae1c72457079ad","78":"69ffc5c559107845c9e1","79":"bd7c1873316a9e772194","80":"e6b6ea0da11777fec65e","81":"c4ff360eb13c47cb2f59","82":"813192532e3170369986","83":"c2e8ab1314c5b7fb01e8","84":"89b9503c22f4bc05129e","85":"6ee57672624702f2bb23","86":"d2630da0c663a44d7dbc","87":"47752fc71b73cfac0c78","88":"3b157d1adb7a515cf575","89":"e9b23d8da0920b6db111","90":"ed6949524ffae4cec7b8","91":"25d0f4ebef8edb564e30","92":"3efb0e719b7d9306bd97","93":"c7b8dd024de8e2545f2c","94":"aaccc2d18902ae96ddc3","95":"b9a685470a55b84c49ff","96":"3e5ec97ff372abe045b7","97":"c9466e58b61ee8079da9","98":"4c4b12b46ce14d70d2eb","99":"590a8a44b4fe0555edfd","100":"9b3632f39467a65b9f26","101":"0b88025414ec5db14179","102":"c31e5349de3131e9024e","103":"01b7513e464b51116416","104":"e294225ae0d12a02f1b2","105":"3ff8a0002a2b8d749a51","106":"3a7a4ba57987f39f5988","107":"4e5da12b2f3ca8bd5ec5","108":"cb4fc709a7fa754dd5e0","109":"56ccad95f14c9d3cf3f8","110":"55d941e4990326684dc6","111":"c59c2ce985e82ae632d8","112":"04c2c59c6b8e51f06fac","113":"a84334b8dd74f42736d6","114":"15e838d2e4f552dcb7d1","115":"bbe047bf0adca878da9e","116":"17b680eed7743b2824a5","117":"763b7263b92d8a0f442e","118":"063854dee3e8e543fb18","119":"6776b579f77b12957774","120":"5a1341bdcd920625cb29","121":"0dab7355f3a5589c7d12","122":"73bbb4f3070f9c7caa35","124":"b287e66d012cadcc8bd4","125":"baa405f443113242b998","126":"8b7b287097d67151b217","127":"06f48df1b83f4a473299","128":"d2762f4301cdb59ab672","129":"5a61b0580c9ab6cb8b4e","130":"28c7477bf82ea8a7080e","131":"1c1d34dd373acad51bdb","132":"c7b9b0f07bfa15d1deb2","133":"6669ccb480afef0825b1","134":"f7e27e06161c715ae844","135":"fd940976c13407bf99f5","136":"6cb082234f4ead4e3c2b","137":"bc3b9b7fc32a9de8ccfe","138":"61e17963f3485c1140cc","139":"9162ca3ca3acd3342ea7"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"33":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"29":"menuDe","30":"menuEn","31":"menuEs","32":"menuFr","33":"styles","124":"staticTextDe","125":"staticTextES","126":"staticTextEn","127":"staticTextEs","128":"staticTextFr","129":"videojsplugins"}[chunkId]||chunkId) + "." + {"0":"2b3b9a827176a0cd9d34","1":"fb0c25a7ce60c8ce8747","2":"575b435c8b036af65191","3":"3788067a0f03e3d9c5a4","4":"c4620e78836f7f74b09a","5":"55841277901c03dabc6c","6":"be78d45ff9a8c3cdf0a4","7":"dbdea9a6148078c54dc1","8":"8557c96dd13d44a0ef91","9":"55fcdb8ad82856bb69df","10":"bec38e57d67c07bc12e5","11":"d3211a9a4449f1843d65","12":"b31f6379fe597116aecb","13":"129dd1089af1dfc2f0d1","14":"f9c369befbcc2347b028","15":"dbd5ebfcd2eb5705c820","16":"b4839e119385d0175106","17":"02097a202037a4ef4778","18":"1a40b11cd4428289f468","19":"0a7886e01f7cb746b738","20":"44d3ce1554fccc4575ed","21":"523613b2cddedadfb88f","22":"85cf0430fdef32381717","23":"bcf9bdb8c151f4665c95","24":"68672826f07699bfa284","25":"9f6102d6949253df30fa","26":"8da4af36c293f95ea570","27":"816b8eff575a2b8694a5","28":"f0339d32b48b79b03940","29":"e8ef9f7b42bf4ec6c41e","30":"f99319952115f42914a6","31":"acf2b4c64e1250ecc5b6","32":"9084f8323c90bf3c841c","33":"6369957b5b09a0223376","34":"59bd11e96a1635ab87dd","35":"578e6bcbdb84d285244f","36":"3bc097ef84ba680bafdb","37":"a8464dfc8be7e7daab36","38":"b1bbb565dd95693a16c8","39":"9e483bdf45ab8cf21b84","40":"2f5c59ec909d58a64008","41":"d0e8965e427f9f4c64a6","42":"55f4c2f41e43ac802fbb","43":"715608c772f8fdcd244e","44":"b7d9f5a1c0dc48e03710","45":"1184065d2a0084cc416e","46":"3f604c63b8f73994fc3f","47":"a36135c84c037ef56213","48":"3ee8994c8f70070ee3aa","49":"8352e1e8aaf86a5c0667","50":"b7fc21e7146fe41a5d35","51":"98a6d0048ebaabcee159","52":"0d0f2046f38f5722cd9c","53":"38fbe47c1525d74f4cb7","54":"861092ec960a57509ad1","55":"5d7029b3f8d0783ca6b3","56":"691b45f0171611746c02","57":"d4e63f3fca5bb6971a1c","58":"3def24c1d14c61e8f43f","59":"54977a35552c8ba73d0f","60":"57faae1e51a8d67993b5","61":"f280ad30b42c9f18789c","62":"3c18a7653217284086d7","63":"571e217d2f5ad5ec1171","64":"5aaac4c8f88d5b999309","65":"eb1e777f6c3351b98d14","66":"406d121b62b6d0fedd11","67":"b8537d12ddc939824d0b","68":"f52c445734810a4a7dfe","69":"d1a87436634f6d04ea56","70":"d299ff722af37d5ed8e4","71":"24ae86a1403a3015b376","72":"9fda1f9ddfcb57fa3830","73":"9ece92cd8ac4a162dace","74":"bf73a066fc56784a70c0","75":"6e2c8ac2bd93579ac92c","76":"54475f156a3fc78ce8b1","77":"f85a0bae1c72457079ad","78":"69ffc5c559107845c9e1","79":"bd7c1873316a9e772194","80":"e6b6ea0da11777fec65e","81":"c4ff360eb13c47cb2f59","82":"813192532e3170369986","83":"c2e8ab1314c5b7fb01e8","84":"89b9503c22f4bc05129e","85":"6ee57672624702f2bb23","86":"d2630da0c663a44d7dbc","87":"47752fc71b73cfac0c78","88":"3b157d1adb7a515cf575","89":"e9b23d8da0920b6db111","90":"ed6949524ffae4cec7b8","91":"25d0f4ebef8edb564e30","92":"3efb0e719b7d9306bd97","93":"c7b8dd024de8e2545f2c","94":"aaccc2d18902ae96ddc3","95":"b9a685470a55b84c49ff","96":"3e5ec97ff372abe045b7","97":"c9466e58b61ee8079da9","98":"4c4b12b46ce14d70d2eb","99":"590a8a44b4fe0555edfd","100":"9b3632f39467a65b9f26","101":"0b88025414ec5db14179","102":"c31e5349de3131e9024e","103":"01b7513e464b51116416","104":"e294225ae0d12a02f1b2","105":"3ff8a0002a2b8d749a51","106":"3a7a4ba57987f39f5988","107":"4e5da12b2f3ca8bd5ec5","108":"cb4fc709a7fa754dd5e0","109":"56ccad95f14c9d3cf3f8","110":"55d941e4990326684dc6","111":"c59c2ce985e82ae632d8","112":"04c2c59c6b8e51f06fac","113":"a84334b8dd74f42736d6","114":"15e838d2e4f552dcb7d1","115":"bbe047bf0adca878da9e","116":"17b680eed7743b2824a5","117":"763b7263b92d8a0f442e","118":"063854dee3e8e543fb18","119":"6776b579f77b12957774","120":"5a1341bdcd920625cb29","121":"0dab7355f3a5589c7d12","122":"73bbb4f3070f9c7caa35","124":"b287e66d012cadcc8bd4","125":"baa405f443113242b998","126":"8b7b287097d67151b217","127":"06f48df1b83f4a473299","128":"d2762f4301cdb59ab672","129":"5a61b0580c9ab6cb8b4e","130":"28c7477bf82ea8a7080e","131":"1c1d34dd373acad51bdb","132":"c7b9b0f07bfa15d1deb2","133":"6669ccb480afef0825b1","134":"f7e27e06161c715ae844","135":"fd940976c13407bf99f5","136":"6cb082234f4ead4e3c2b","137":"bc3b9b7fc32a9de8ccfe","138":"61e17963f3485c1140cc","139":"9162ca3ca3acd3342ea7"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");

 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				var onLinkComplete = function (event) {
 					// avoid mem leaks.
 					linkTag.onerror = linkTag.onload = null;
 					if (event.type === 'load') {
 						resolve();
 					} else {
 						var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 						var realHref = event && event.target && event.target.href || fullhref;
 						var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
 						err.code = "CSS_CHUNK_LOAD_FAILED";
 						err.type = errorType;
 						err.request = realHref;
 						delete installedCssChunks[chunkId]
 						linkTag.parentNode.removeChild(linkTag)
 						reject(err);
 					}
 				};
 				linkTag.onerror = linkTag.onload = onLinkComplete;
 				linkTag.href = fullhref;

 				(function insert(linkTag) {
 				      if (document.querySelector('#assets-main-stylesheet')) {
 				        return;
 				      }
 				      document.head.appendChild(linkTag);
 				    })(linkTag)
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 779);
